import { Toaster as Sonner, type ToasterProps } from "sonner"

/**
 * Wrapper shadcn de sonner, sans next-themes : l'application n'a pas de thème sombre
 * (index.css), inutile d'embarquer une bibliothèque pour lire un réglage absent.
 */
const Toaster = (props: ToasterProps) => (
  <Sonner
    theme="light"
    className="toaster group"
    style={
      {
        "--normal-bg": "var(--popover)",
        "--normal-text": "var(--popover-foreground)",
        "--normal-border": "var(--border)",
      } as React.CSSProperties
    }
    {...props}
  />
)

export { Toaster }
